import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './StatusGmin.css';
import { Button, Grid, Well, Row, Col, PageHeader, Pagination, Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import fetch from '../../core/fetch/fetch.server';
import waiting from './waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import DatePicker from 'react-bootstrap-date-picker';
import Link from '../../components/Link/Link';
import _ from 'lodash';
import { fetchDistrictServices } from '../../actions/district';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';


const btnStyle = {
  width: '100%'
};

class StatusGmin extends React.Component {

  state = {
    selected_district: null,
    filter_text: '',
    isMounted: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  };


  async fetchDistrictServicesWrapper() {
    try {
      const resp = await this.props.fetchDistrictServices();

      const prefix = this.props.districts[Object.keys(this.props.districts).sort()[0]].prefix;
      const selected_distr = _.find(this.props.all_eservices, (o) => (o.prefix === prefix));
      this.setState({ selected_district: selected_distr, isMounted: true });

    } catch (err) {
      console.log(err)
    }
  }

  componentDidMount() {
    this.fetchDistrictServicesWrapper();
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  onClick = (item) => {
    const prefix = this.props.districts[item].prefix;
    this.setState({ selected_district: _.find(this.props.all_eservices, (o) => (o.prefix === prefix)) });
  };

  districtFilterChange = (e) => {
    //zamiana kilku spacji na jedną
    const value = e.target.value.replace(/\s\s+/g, ' ');
    this.setState({ filter_text: value });
  };

  renderView = () => {
    return (
      <div className={s.sgContainer} style={this.state.style}>
        <Grid style={{ width: '100%' }}>
          <Row>
            <Col xs={3}>
              <div className={'well well-sm'} style={{ background: this.state.style.backgroundColor }}>
                <h4 style={{ textAlign: 'center' }}>
                  <b>Gminy:</b>
                </h4>
                <input type="text"
                  className="form-control"
                  style={{ width: '100%', position: 'relative', margin: '25px 0px 15px 0px' }}
                  value={this.state.filter_text}
                  placeholder="Wyszukaj urząd..."
                  onChange={(e) => this.districtFilterChange(e)}
                />
                <ul className={'nav flex-column'} style={{ height: '600px', overflowY: 'scroll' }}>
                  {this.props.districts && Object.keys(this.props.districts).sort()
                    .filter(item => this.props.districts[item].showOnList === true)
                    .filter(item => this.props.districts[item].name.toLowerCase().includes(this.state.filter_text.toLowerCase()))
                    .map(item => (

                      <li className={'nav-item'} key={item}>
                        <button
                          type="button"
                          className={'btn btn-primary'}
                          style={btnStyle}
                          onClick={() => this.onClick(item)}
                        >
                          {this.props.districts[item].name}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
            </Col>
            <Col xs={9}>
              <Row>
                {this.state.selected_district ? <h4 style={{ textAlign: 'left' }}>
                  <b>{this.state.selected_district.name}:<br></br><br></br></b>
                </h4> : null}
              </Row>
              <Row>
                <table style={{ width: '100%' }}>
                  <tr>
                    <th style={{ width: '10%', textAlign: 'center' }}>Płatności:</th>
                    <th style={{ width: '15%', textAlign: 'center' }}>
                      {this.state.selected_district.payment_methods.length ?
                        <input type="text" disabled className={'form-control'} style={{ color: 'green', textAlign: 'center' }} value='TAK' /> :
                        <input type="text" disabled className={'form-control'} style={{ color: 'red', textAlign: 'center' }} value='NIE' />}
                    </th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Nr konta:</th>
                    <th style={{ width: '30%', textAlign: 'center' }}>
                      {this.state.selected_district.bankAccounts.map((account => {
                        return (
                          <input type="text" disabled className={'form-control'} style={{ textAlign: 'center' }} value={account} />
                        );
                      }))}
                    </th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Rodzaj:</th>
                    <th style={{ width: '25%', textAlign: 'center' }}>
                      <input type="text" disabled className={'form-control'} style={{ textAlign: 'center' }} value={this.state.selected_district.payment_methods.join('/')} />
                    </th>
                  </tr>
                </table>
              </Row>
              <Row>
                <Col className="rwd-class" xs={2}>
                  <h5 style={{ textAlign: 'left' }}>
                    <b>Lista usług:</b>
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col className="rwd-class" xs={12}>
                  <table className={'table'}>
                    <thead className={'thead-light'}>
                      <tr>
                        <th style={{ width: '50%', textAlign: 'center' }}><b>Nazwa usługi:</b></th>
                        <th style={{ width: '21%', textAlign: 'center' }}><b>Adresy e-mail:</b></th>
                        <th style={{ width: '21%', textAlign: 'center' }}><b>Skrytka ePUAP:</b></th>
                        <th style={{ width: '8%', textAlign: 'center' }}><b>Wysyłka?</b></th>
                      </tr>
                    </thead>
                  </table>
                  {this.state.selected_district ?
                    <ul className={'nav flex-column'} style={{ height: '550px', overflowY: 'auto', width: '100%' }}>
                      {this.state.selected_district.services.map((service => {
                        return (
                          <li className={'nav-item'}>

                            <table style={{ width: '100%' }}>
                              <tr>
                                <td style={{ width: '50%', textAlign: 'justify', padding: '0px 5px' }}>{service.title}</td>
                                <td style={{ width: '21%', textAlign: 'center', padding: '0px 5px' }}>
                                  {service.emails.length > 0 ?
                                    service.emails.map((email => {
                                      return (
                                        <input type="text" disabled className={'form-control'} style={{ textAlign: 'center' }} value={email} />
                                      );
                                    })) :
                                    <input type="text" disabled className={'form-control'} style={{ overflow: 'auto', textAlign: 'center' }} value='' />}
                                </td>
                                <td style={{ width: '21%', textAlign: 'center', padding: '0px 5px' }}>
                                  <input type="text" disabled className={'form-control'} style={{ textAlign: 'center' }} value={service.skrytkaEPUAP ? service.skrytkaEPUAP : ''} />
                                </td>

                                <td style={{ width: '8%', textAlign: 'center', padding: '0px 5px' }}>
                                  {service.sendToEpuap ?
                                    <input type="text" disabled className={'form-control'} style={{ color: 'green', textAlign: 'center' }} value='Wł.' /> :
                                    <input type="text" disabled className={'form-control'} style={{ color: 'red', textAlign: 'center' }} value='Wył.' />}
                                </td>
                              </tr>
                            </table>
                            <hr style={{ marginTop: '2px', marginBottom: '2px' }}></hr>
                          </li>
                        );
                      }))}
                    </ul> : null}
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  render() {
    return (this.state.isMounted ? this.renderView() : (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}
      >
        <img role="presentation" src={waiting} />
      </GrayPanel>))

  }
}

const mapState = state => ({

  username: state.user ? state.user.username : '',
  districts: state.district.districts,
  all_eservices: state.district.districtServicesData
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles(s)(connect(mapState, mapDispatch)(StatusGmin));



// WEBPACK FOOTER //
// src/routes/StatusGmin/StatusGmin.js